<template>
	<div class="text-container">
		<div class="title">服务条款和隐私政策</div>
		<div class="numtitle">一、服务概述</div>
		<div>
			本服务条款和隐私政策是用户（您）与中国联合网络通信有限公司（下称“本公司”、“中国联通”）之间关于用户登录、使用“手机号一键登录”服务所订立的协议，使用包括中国联通所运营的“手机号一键登录”服务。本公司在此特别提醒用户认真阅读、充分理解本《服务条款和隐私政策》（下称“协议”），并 
			<span style="font-weight: bold;">慎重选择接受或不接受本《协议》（如果您未满14周岁，请在法定监护人的陪同下阅读，并注意未成年人保护条款）。除非您接受本《协议》所有条款，否则您无权使用“手机号一键登录”服务。您的登录、使用等行为将视为对本《协议》的接受、认可，并同意接受本《协议》各项条款的约束。</span>
			本《协议》描述本公司与用户之间关于“手机号一键登录”服务相关方面的权利义务。“用户”是指登录、使用本服务的个人或组织。 
			<span style="font-weight: bold;">
				您对本协议的接受即受全部条款的约束，包括接受中国联通对本服务条款随时所做的任何修改。您同意本公司有权以网页公告 (网址：
				<a href="https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true" style="">https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true</a>
				)等合理方式通知您修改本《协议》条款，您在享受本服务时，应及时查阅了解修改的内容；若您在本《协议》内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议内容，也将遵守修改后的协议内容使用本服务；若您不同意修改后的协议内容，请立即停止使用“手机号一键登录”提供的服务。
			</span>
		</div>
		<div class="numtitle">二、用户个人信息保护</div>
		<div>2.1、个人信息的收集、使用</div>
		<div>本服务包含一些核心功能，这些功能包含了实现产品或服务所必须的功能。本公司可以收集和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受本公司提供的产品与/或服务。这些功能包括：</div>
		<div class="text-l-rem">2.1.1 为了实现一键登录功能，本公司会收集、使用您的网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商。</div>
		<div class="text-l-rem">2.1.2 为了实现业务风控功能，使用您手机操作系统、硬件厂商、运营商类型、网络类型。</div>
		<div>2.2、个人信息的共享</div>
		<div>由于本服务用于APP上手机号码一键登录的应用场景，本公司在您授权同意下，有权将您的手机号码共享给您授权同意使用的APP上。</div>
		<div>2.3、个人信息的存储 </div>
		<div>本公司收集的个人信息将存储在中华人民共和国境内，按照法律规定范围内的最短期限存储个人信息，超出存储期限将自动清理。</div>
		<div>2.4、本公司对您个人信息的保护措施</div>
		<div class="text-l-rem"> 2.4.1 本公司采用行业标准惯例以保护用户的个人信息，除法律法规另有规定或有关法律要求向司法机关和政府部门提供外，未经您的同意，本公司不会向第三方以外的公司、组织和个人披露您的个人信息。</div>
		<div class="text-l-rem">2.4.2 本公司会有完善的管理制度和安全措施来保护您的个人信息，以免遭受未经授权的访问、使用或披露。但由于技术水平限制及可能存在的各种恶意手段，有可能因我们可控范围外的因素而出现安全问题。在发生个人信息安全事件后，本公司将按照相关法律法规及监管政策的要求，及时向您告知：安全事件的基本情况和可能影响、本公司已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。本公司将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，本公司会采取合理、有效的方式发布公告。同时，本公司还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</div>
		<div>2.5、授权同意的例外</div>
		<div>您了解并同意，以下情形中本公司使用个人信息无需征得您的授权同意：</div>
		<div class="text-l-rem">（1）与国家安全、国防安全有关的；</div>
		<div class="text-l-rem">（2）与公共安全、公共卫生、重大公共利益有关的；</div>
		<div class="text-l-rem">（3）与犯罪侦查、起诉、审判和判决执行等有关的；</div>
		<div class="text-l-rem">（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</div>
		<div class="text-l-rem">（5）所收集的个人信息是个人信息主体自行向社会公众公开的；</div>
		<div class="text-l-rem">（6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</div>
		<div class="text-l-rem">（7）根据您的要求签订和履行合同所必需的；</div>
		<div class="text-l-rem">（8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</div>
		<div class="text-l-rem">（9）法律法规及监管政策规定的其他情形。</div>
		<div>2.6、脱敏信息的商用化应用：</div>
		<div>在符合相关法律法规前提下，本公司可能会采取技术手段对用户个人信息进行去标识化处理，形成无法识别用户身份的脱敏信息。请您了解并同意，在此情况下本公司有权使用已经去标识化的信息，并在不透露您隐私信息的前提下，有权对用户数据库进行分析并予以商业化的利用。</div>
		<div>2.7、用户处理个人信息权利</div>
		<div>根据您所适用的国家或地区法律法规，您有权要求访问、更正、删除本公司持有的与您相关的任何个人信息。在以下情形中，您可以向本公司提出删除个人信息的请求：</div>
		<div class="text-l-rem">（1）如果我们处理个人信息的行为违反法律法规；</div>
		<div class="text-l-rem">（2）如果我们收集、使用您的个人信息，却未征得您的同意；</div>
		<div class="text-l-rem">（3）如果我们处理个人信息的行为违反了与您的约定；</div>
		<div class="text-l-rem">（4）如果您不再使用我们的产品或服务；</div>
		<div>当您从本公司的服务中删除信息后，本公司可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。本公司可能会先要求您验证自己的身份，然后再处理您的要求，本公司将在15天内做出答复。</div>
		<div>2.8、未成年人个人信息的保护 </div>
		<div>本公司非常重视对未成年人个人信息的保护。若您是不满14周岁的未成年人，在使用我们的服务前，应事先取得您监护人的同意。本公司仅在法律法规允许、未成年人的监护人明确同意或者有必要保护未成年人的情况下使用、对外提供或公开披露该信息。若您是未成年人的监护人，请您关注您监护的未成年人是否是在取得您的授权同意之后使用本服务。如果您对您所监护的未成年人的个人信息有疑问，请通过本协议项下的联系方式与我们联系。</div>
		<div class="numtitle">三、服务风险</div>
		<div>3.1、您须明白，本服务仅依其当前所呈现的状况提供，本服务涉及到互联网及相关通信等服务，可能会受到各个环节不稳定因素的影响。因此服务存在因上述不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机、通信网络、互联网络原因等造成的服务中断或不能满足用户要求的风险。使用服务的用户须承担以上风险，本公司对服务之及时性、安全性、准确性不作担保。</div>
		<div>3.2、本公司的系统发生故障影响到本服务的正常运行，本公司承诺及时与相关单位配合，及时处理进行修复。此外，为保证本公司提供服务的流畅性，本公司将在中国联通网站做出相应公示后，对系统进行维修保养、升级或其他目的而暂停提供本服务。</div>
		<div>3.3、您自本公司工作人员或经由本服务取得的建议或资讯，无论其为书面或口头，均不构成本公司的任何保证，中国联通对此不承担任何责任。</div>
		<div>3.4、若您允许手机自动向本服务发送短信以达到一键登录功能，所产生一切费用及后果本公司不承担任何责任。</div>
		<div class="numtitle">四、法律适用</div>
		<div>本服务条款要与国家相关法律、法规一致，如发生服务条款与相关法律、法规条款有相抵触的内容，抵触部分以法律、法规条款为准。</div>
		<div class="numtitle">五、争议管辖条款</div>
		<div>本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生之争议，均应依照中华人民共和国法律予以处理。若用户和中国联通之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户在此完全同意将纠纷或争议提交中国联通主营业务所在地（即北京市西城区）有管辖权的人民法院管辖。</div>
		<div class="numtitle">六、保障</div>
		<div>6.1、用户同意保障和维护本公司全体成员的利益，负责支付由用户使用超出服务范围或不当使用服务引起的一切费用（包括但不限于：律师费用、违反服务条款的损害补偿费用以及其它第三方使用用户的电脑、帐号和其它知识产权的追索费）。</div>
		<div>6.2、用户须对违反国家法律规定及本服务条款所产生的一切后果承担法律责任。</div>
		<div class="numtitle">七、其它</div>
		<div>7.1、如本服务条款中的任何条款无论因何种原因完全或部分无效不影响本服务其他条款的效力。</div>
		<div>7.2、中国联通对于本协议条款在法律范围内进行解释说明。用户如在使用本服务过程中有任何疑问、意见及建议，请随时联系本公司，客服电话：4000096800。</div>
		<div style="text-align: center;margin: 15px 0;">中国联合网络通信有限公司</div>
	</div>
</template>
	
<script>
	export default {
		data() {
			return {};
		},
		computed: {
		}
	};
</script>

<style lang="less" scoped>
	.text-container {
		padding: 0 30px 50px;
		word-break:break-all;
		div {
			padding: 2px 0;
		}
		.title {
			font-size: 30px;
			margin: 15px 0;
			font-weight: bold;
			text-align: center;
		}
		.numtitle {
			font-size: 22px;
			margin: 35px 0 15px;
			font-weight: bold;
		}
		.text-l-rem {
			text-indent: 1rem;
		}
	}
</style>